export const environment = {
    production: true,
    appUrl: 'https://www.shriramwealth.in/',
    env: 'prod',
    appName: 'shriramwealth',
    appDomain: '',
    appDomainUrl: '',
    serverUrl: 'http://127.0.0.1:4000/',
    previewServerUrl: '',
    instance: 'v1',
    assetsCDNUrl: '',
    webSiteUrl: '',
    mapApiKey: '',
    kalamliteApiUrl: "https://cms.shriramwealth.in/api/v1/"

};
